// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-board[data-v-46fe9a02]{display:flex;align-items:center;justify-content:center;border:1px solid #e4e7ed;margin-top:20px;padding:20px 0}.svg-btns[data-v-46fe9a02]{margin-top:10px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
